<template>
    <v-layout column justify-center fill-height>
        <div style="flex: 1; overflow: hidden">
            <form-body
                v-model="form"
                v-bind="{
                    index,
                }"
                mode="sign"
                @input="emit"
            />
        </div>
        <v-divider />
        <form-noti v-model="disabled" v-bind="{ form }" />
    </v-layout>
</template>

<script>
import { initEmploymentContract } from "@/assets/variables";

import EmploymentDocSide from "@/components/client/employment/doc/employment-doc-side.vue";
import FormBody from "./form/form-body.vue";
import FormNoti from "./form/form-noti.vue";

export default {
    components: {
        EmploymentDocSide,
        FormBody,
        FormNoti,
    },
    props: {
        /** @type {import('vue').PropType<import('@/assets/variables').EmploymentContract>} */
        value: { type: Object, default: initEmploymentContract },
        shows: { type: Boolean, default: false },
        loading: { type: Boolean, default: false },
    },
    data: () => ({
        form: initEmploymentContract(),
        index: 0,
        disabled: undefined,
    }),
    computed: {
        pages() {
            return this.form?.form?.pages || [];
        },
    },
    mounted() {
        this.init();
    },
    watch: {
        value() {
            this.sync();
        },
        disabled() {
            this.emitDisabled();
        },
    },
    methods: {
        init() {
            this.emitDisabled();
            this.sync();
        },
        sync() {
            this.form = initEmploymentContract(this.value);
        },
        emit() {
            this.$emit("input", this.form);
        },
        emitDisabled() {
            this.$emit("setDisabled", this.disabled);
        },
    },
};
</script>
